"use client";
import { Fragment, useEffect } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import Link from "next/link";
import Logout from "@/components/Buttons/Logout";
import { useSetAtom } from "jotai";
import { userAtom } from "@/lib/atoms/user";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const AccountLinks = [
  { name: "account", href: "/account" },
  { name: "Billing", href: "/account/billing" },
  { name: "private numbers", href: "/account/private-number" },
  { name: "Data Roaming eSIM", href: "/global-esim-data-roaming" },
];

export default function UserAccountDialogClient({ userInfo, userError }) {
  const setUser = useSetAtom(userAtom);

  useEffect(() => {
    setUser(userInfo);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo]);

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button className="border inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-500 hover:bg-gray-50">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-5 h-5 text-gray-400"
            >
              <path
                fillRule="evenodd"
                d="M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
                clipRule="evenodd"
              />
            </svg>
          </span>{" "}
          Account
          <ChevronDownIcon
            className="-mr-1 h-5 w-5 text-gray-400"
            aria-hidden="true"
          />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none will-change-transform">
          <div className="py-1">
            {userError ? (
              <div className="w-full  py-2 px-4 space-y-1 border-b ">
                <p className="text-red-600 font-semibold w-full h-full text-start capitalize block text-xs">
                  Error: Unable To Get User info
                </p>
              </div>
            ) : (
              <div className="w-full  py-2 px-4 space-y-1 border-b ">
                <p className=" font-semibold w-full h-full text-start capitalize block text-xs">
                  {userInfo?.email}
                </p>
                <p className="font-medium w-full h-full text-start capitalize block text-xs">
                  Balance: ${userInfo?.balance}
                </p>
              </div>
            )}

            {AccountLinks.map((link) => (
              <Menu.Item key={link.name}>
                {({ active }) => (
                  <Link
                    href={link.href}
                    className={classNames(
                      active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                      "capitalize block px-4 py-2 text-sm"
                    )}
                  >
                    {link.name}
                  </Link>
                )}
              </Menu.Item>
            ))}
          </div>

          <Menu.Item>
            <Logout />
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
